<template>
  <div class="DarkWhite pa-4">
      <h2 class="subheading green--text">Budget Purpose</h2>
      <v-card class="mt-4">
      <BudgetPurpose/>
  </v-card>
  </div>
</template>

<script>
import BudgetPurpose from '@/components/Utils/BudgetPurpose.vue'
  export default {
    components: {
      BudgetPurpose
    },
    data: () => ({
    }),
  }
</script>

<style scoped>
</style>
